module.exports = __webpack_public_path__ + "static/media/motor.c909331d.jpg";